import Al_Qaytharah from "./SuccessStory/Al-Qaytharah.png";
import Latte_Free from "./SuccessStory/Latte_Free.png";
import Desert_Nights_Resort from "./SuccessStory/Desert_Nights_Resort.png";
import The_Med_Soul from "./SuccessStory/The_Med_Soul.png";
import Rangle_Rajasthan from "./SuccessStory/Rangle_Rajasthan.png";
import DJ_Just from "./SuccessStory/DJ_Just.png";
import Digii_School from "./SuccessStory/Digii_School.png";
import J_Qube_Foundation from "./SuccessStory/J_Qube_Foundation.png";
import axios from "axios";
import { useEffect, useState } from "react";

const cardData = [
  {
    img: Al_Qaytharah,
    category: "CONSTRUCTION COMPANY",
    title: "Al Qaytharah’s Online Presence: Innovation Meets Excellence",
    description:
      "Versai Tech Solutions developed alqaytharah.com, showcasing Al Qaytharah’s construction expertise with sleek design, innovation, and user-friendly features.",
    details:
      "Modern website highlights services, 200+ projects, Dubai-based office, contact details, and Al Qaytharah's commitment to excellence.",
    className: "bg-[#eae9ee] ",
    link: "https://alqaytharah.com/",
  },
  {
    img: Latte_Free,
    category: "HEALTHCARE APP",
    title: "Latte Free: Transforming Lives, One Step at a Time",
    description:
      "Versai Tech Solutions developed Latte Free, a user-friendly app helping users overcome smoking and alcohol addiction, promoting healthier lives.",
    details:
      "Quit Mate empowers users to quit smoking and drinking, offering personalized features and progress tracking for addiction-free living.",
    className: "bg-[#eae9ee] py-8",
    link: "https://versai.in/Contact-us/",
  },
  {
    img: Desert_Nights_Resort,
    category: "HOTEL/RESORT",
    title: "Desert Nights Resort: Stay & Book with Ease",
    description:
      "Versai Tech Solutions crafted a modern website for Desert Nights Resort, offering a smooth and secure booking experience. The platform highlights resort amenities, scenic views, and Mandawa’s cultural charm.",
    details:
      "Optimized for all devices, the platform enhances guest experience with intuitive design and seamless navigation.",
    className: "bg-[#eae9ee] ",
    link: "https://desertnights.in",
  },
  {
    img: The_Med_Soul,
    category: "LEARNING PLATFORM",
    title: "The Med Soul: AI-Powered Medical Learning & Patient Care",
    description:
      "An AI-integrated web platform revolutionizing practical medical education, emergency management, and patient care. It features interactive learning modules, detailed video content with AI-powered summaries and chatbots, and comprehensive course materials.",
    details:
      "Built on MERN stack, it offers intuitive navigation, dynamic course pages, advanced video learning with AI chatbots (Gemini), user authentication, and detailed faculty/about sections.",
    className: "bg-[#eae9ee] ",
    link: "https://themedsoul.com",
  },
  {
    img: Rangle_Rajasthan,
    category: "INDIAN FESTIVAL PLATFORM",
    title: "Rang Le Rajasthan: Your Hub for India's Grand Festivals",
    description:
      "Rang Le Rajasthan is envisioned as the ultimate destination for celebrating India's vibrant festivals like Holi, Diwali, and Garba, bringing diverse cultural experiences together in one place, primarily based in Jaipur.",
    details:
      "We aim to host a spectrum of authentic Indian festivities, offering unique cultural immersion with music, dance, and traditional rituals. From Jaipur to across Rajasthan, experience the true essence of India's grandest celebrations.",
    className: "bg-[#eae9ee] ",
    link: "https://ranglerajasthan.in",
  },
  {
    img: Digii_School,
    category: "EDUCATION TRANSFORMER",
    title: "Digii School: Comprehensive School ERP & Parent Portal",
    description:
      "Digii School is an all-encompassing ERP software designed for efficient school management, featuring dedicated portals for students and parents to enhance communication and academic oversight for a student's best future.",
    details:
      "This ERP system offers modules for attendance, timetables, examinations, progress reports, fees, e-learning, and SMS alerts. It includes integrated dashboards for teaching staff, non-teaching staff, students, and parents, facilitating seamless school operations.",
    className: "bg-[#eae9ee] ",
    link: "https://digiischool.com",
  },
  {
    img: DJ_Just,
    category: "LUXURY RAJASTHAN EVENTS",
    title: "DJ Just: Premier DJ & Event Services in Mandawa, Jhunjhunu",
    description:
      "DJ Just.in offers authentic, luxury DJ, music, and event services for weddings/ceremonies across Mandawa, Jhunjhunu, Rajasthan (Ajit-Garh, Churi-Ajitgarh).",
    details:
      "We provide professional DJ setups, live music, and full event management for celebrations in Mandawa, Jhunjhunu, and heritage sites, ensuring an unforgettable Rajasthani experience.",
    className: "bg-[#eae9ee] ",
    link: "https://djjust.in",
  },
  {
    img: J_Qube_Foundation,
    category: "COMMUNITY DEVELOPMENT",
    title: "J Qube Foundation: Empowering Communities Through Social Impact",
    description:
    "J Qube Foundation is a dedicated NGO focused on driving positive social change and community development. We empower individuals through various initiatives aimed at improving lives.",
    details:
    "Our mission encompasses diverse programs including education, healthcare, and sustainable livelihood support for underserved communities. We strive for a brighter future through impactful, grassroots efforts.",
    className: "bg-[#eae9ee] ",
    link: "https://jqubefoundation.org",
  },
];
const Card = ({
  img,
  category,
  title,
  description,
  details,
  // className,
  link,
}) => (
  <div className="bg-white border rounded-3xl p-3 flex flex-col gap-1 w-full h-full justify-between">
    {/* Use the passed `className` prop for the background */}
    <div
      className={`flex items-center rounded-xl px-4 md:pt-4 pt-0  w-full min-h-[15em] max-h-[23em] overflow-hidden `}
    >
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img
          src={img}
          alt={title}
          className={`w-full h-full rounded-lg object-scale-down p-4 bg-[#eae9ee] `}
        />
      </a>
    </div>
    <div className="md:min-h-[20em]">
      <h2 className="text-xs sm:text-sm md:text-base font-bold text-gray-500 mt-4 mb-2">
        {category}
      </h2>
      <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-sm sm:text-base text-justify text-[#6b6b75] mb-4 font-semibold">
        {description}
      </p>
      <p className="text-sm sm:text-base text-justify text-[#6b6b75] font-semibold">
        {details}
      </p>
    </div>
  </div>
);

// const Card = ({
//   images,
//   project_type,
//   project_name,
//   para1,
//   para2,
//   // className,
//   link,
// }) => (
//   <div className="bg-white border rounded-3xl p-3 flex flex-col gap-1 w-full h-full justify-between">
//     {/* Use the passed `className` prop for the background */}
//     <div
//       className={`flex items-center rounded-xl px-4 md:pt-4 pt-0  w-full min-h-[15em] max-h-[23em] overflow-hidden `}
//     >
//       <a href={link} target="_blank" rel="noopener noreferrer">
//         <img
//           src={images?.[0]}
//           alt={project_name}
//           className={`w-full h-full rounded-lg object-scale-down p-4 bg-[#eae9ee] `}
//         />
//       </a>
//     </div>
//     <div className="md:min-h-[20em]">
//       <h2 className="text-xs sm:text-sm md:text-base font-bold text-gray-500 mt-4 mb-2">
//         {project_type}
//       </h2>
//       <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2">
//         {project_name}
//       </h3>
//       <p className="text-sm sm:text-base text-justify text-[#6b6b75] mb-4 font-semibold">
//         {para1}
//       </p>
//       <p className="text-sm sm:text-base text-justify text-[#6b6b75] font-semibold">
//         {para2}
//       </p>
//     </div>
//   </div>
// );



const Success = () => {
  
  // const [data, setData] = useState([])

  // useEffect(()=>{
  //   ;(async ()=>{
  //     try {
  //       const res = await axios.get('https://9000.guildarts.online/projects',
  //         {
  //           headers: {
  //            "Content-Type": "application/json"
  //           }
  //         }
  //       );
  //       if(res.status === 200){
  //         // console.log('all data', res.data);
  //         setData(res.data)
  //       }
  //     } catch (error) {
  //       console.log('error', error);
  //     }
  //   })();
  // },[])
  
  return (
  <div className="py-20  ">
    <div className="container  mx-auto lg:px-20 px-2 md:px-4 lg:py-8">
      <div className="text-left mb-8">
        <button className="bg-gray-200 text-[12px] font-bold text-gray-700 px-4 py-2 rounded-md mb-4">
          WHERE WE DO
        </button>
        <h1 className="text-4xl font-bold text-gray-900">Success Stories</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 w-full   gap-6">
        {cardData.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </div>
  </div>
); }

export default Success;
